module.exports = __webpack_public_path__ + "img/config-icon.480eea2a.svg";